import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Tag,
  IconButton,
  Flex,
} from "@chakra-ui/react";
import { ReactComponent as Edit2 } from "assets/svgs/edit.svg";
import { useNavigate } from "react-router-dom";

const DashboardTable = ({ products }) => {
  const navigate = useNavigate();

  const getStatusBackgroundColor = (status) => {
    switch (status?.toLowerCase()) {
      case "multiple":
        return "#456EFF1A";
      case "live":
      case "shopify":
        return "#00FF3810";
      case "sold":
        return "#FF000016";
      case "photo":
      case "photography":
      case "preview":
        return "#FFC70016";
      case "hidden":
        return "#74787B10";
      case "rejected":
        return "#B92C5316";
      case "dry-cleaning":
      case "dry cleaning":
        return "#5450A310";
      default:
        return "#FFC70010";
    }
  };

  const getStatusTextColor = (status) => {
    switch (status?.toLowerCase()) {
      case "multiple":
        return "#456EFF";
      case "live":
      case "shopify":
        return "#00FF38";
      case "sold":
        return "#FF0000";
      case "photo":
      case "photography":
      case "preview":
        return "#FFC700";
      case "hidden":
        return "#74787B";
      case "rejected":
        return "#B92C53";
      case "dry-cleaning":
      case "dry cleaning":
        return "#5450A3";
      default:
        return "#FFC700";
    }
  };

  // console.log("products", products);
  const capitalizeStatus = (status) => {
    if (!status) return "";
    return status
      .replace(/-/g, " ") // replace hyphens with spaces
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <Box bg="white" p="6" borderRadius="20px" boxShadow="md" w={"100%"}>
      {/* Header Section */}
      <Box mb="3">
        <Flex flex={1} direction={"row"} justifyContent={"space-between"}>
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"24px"}
            lineHeight={"100%"}
            fontWeight={500}
            color={"#000000"}
          >
            Products
          </Text>
          <Button
            fontFamily={"PlusJakartaSansMedium"}
            fontWeight={500}
            fontSize={"14px"}
            colorScheme={"#fffff"}
            backgroundColor={"#456EFF"}
            size="sm"
            paddingX={"8"}
            paddingY={"5"}
            width={"100px"}
            mt={2}
            onClick={() => navigate("/products")}
          >
            View All
          </Button>
        </Flex>
        <Text
          fontSize="xs"
          color="#456EFF80"
          fontFamily={"PlusJakartaSansRegular"}
          mt="1"
        >
          Recent
        </Text>
      </Box>

      {/* Table Wrapper with Scrollable Body */}
      <Box overflowX="auto">
        <Box
          maxH="380px"
          overflowY="auto"
          css={{
            "&::-webkit-scrollbar": { display: "none" },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Table size="sm">
            {/* Fixed Header */}
            <Thead
              position="sticky"
              top="0"
              zIndex="1"
              padding={10}
              height={20}
              bg={"#fff"}
            >
              <Tr>
                <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  SKU
                </Th>
                <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  PRODUCT TITLE
                </Th>
                <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  LOCATION
                </Th>
                <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  AGE/SIZE
                </Th>
                <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  STATUS
                </Th>
                {/* <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  APPROVAL STATUS
                </Th> */}
                {/* <Th
                  color={"#898989"}
                  fontSize={"16px"}
                  fontWeight={"500"}
                  fontFamily={"PlusJakartaSansRegular"}
                >
                  ACTION
                </Th> */}
              </Tr>
            </Thead>

            {/* Scrollable Body */}
            {/* {console.log("products", products)} */}
            <Tbody>
              {products?.length === 0 ? (
                <Tr>
                  <Td
                    colSpan={4}
                    textAlign="center"
                    py={10}
                    borderBottom="none"
                  >
                    <Text
                      fontFamily="PlusJakartaSansMedium"
                      fontSize="16px"
                      color="#898989"
                    >
                      No products found!
                    </Text>
                  </Td>
                </Tr>
              ) : (
                <>
                  {products.map((product, index) => (
                    <Tr
                      key={index}
                      bg={index % 2 === 0 ? "#F7F7F7" : "#FFFFFF"}
                      height="76px"
                    >
                      <Td
                        fontFamily={"PlusJakartaSansRegular"}
                        fontSize={"16px"}
                        color={"#000000"}
                        fontWeight={"400"}
                      >
                        {product?.variants?.sku}
                      </Td>
                      <Td
                        fontFamily="PlusJakartaSansRegular"
                        fontSize="16px"
                        color="#000000"
                        maxW="100px"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                      >
                        {product?.product_title}
                      </Td>
                      <Td
                        fontFamily={"PlusJakartaSansRegular"}
                        fontSize={"16px"}
                        color={"#000000"}
                      >
                        {product?.variants?.instances?.location?.name}
                      </Td>
                      <Td
                        fontFamily={"PlusJakartaSansRegular"}
                        fontSize={"16px"}
                        color={"#000000"}
                      >
                        {product?.variants?.age_detail?.age_value}
                      </Td>
                      <Td>
                        <Tag
                          bg={getStatusBackgroundColor(
                            product?.variants?.instances?.status
                          )}
                          borderRadius="full"
                          px="3"
                          py={"2"}
                          w={"auto"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          color={getStatusTextColor(
                            product?.variants?.instances?.status
                          )}
                          fontFamily={"PlusJakartaSansRegular"}
                          fontSize={"16px"}
                        >
                          <Box
                            bg={getStatusTextColor(
                              product?.variants?.instances?.status
                            )}
                            width={"8px"}
                            height={"8px"}
                            borderRadius={50}
                            marginRight={"8px"}
                          />
                          {product?.variants?.instances?.status?.toLowerCase() ===
                          "shopify"
                            ? "Live"
                            : product?.variants?.instances?.status?.toLowerCase() ===
                              "dry-cleaning"
                            ? "Dry Cleaning"
                            : product?.variants?.instances?.status?.toLowerCase() ===
                            "photography"
                          ? "Photo"
                            : capitalizeStatus(product?.variants?.instances?.status)}
                        </Tag>
                      </Td>
                      {/* <Td>
                    <Tag
                      bg={"none"}
                      px="3"
                      w={"100%"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      fontFamily={"PlusJakartaSansRegular"}
                      fontSize={"16px"}
                    >
                      -
                    </Tag>
                  </Td> */}
                      {/* <Td>
                    <IconButton
                      icon={<Edit2 />}
                      aria-label="Edit"
                      variant="ghost"
                      color="gray.500"
                      onClick={() => console.log("Edit product")}
                    />
                  </Td> */}
                    </Tr>
                  ))}
                </>
              )}
            </Tbody>
          </Table>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardTable;
